(()=>{'use strict';
 const init=(scope=document)=>{
  scope.querySelectorAll('.mm-editorial').forEach(root=>{
   if(root.dataset.mmReady)return;root.dataset.mmReady='true';
   const toc=root.querySelector('.mm-toc');
   if(toc&&matchMedia('(max-width:800px)').matches)toc.open=false;
   const tocLinks=[...root.querySelectorAll('.mm-toc a[href^="#"]')];
   if(tocLinks.length&&toc&&!toc.dataset.mmSpyReady){
    toc.dataset.mmSpyReady='true';
    const owner=toc.closest('.shopify-section')||root;
    const targets=tocLinks.map(link=>({link,target:document.getElementById(link.hash.slice(1))})).filter(item=>item.target);
    let frame=null;
    const update=()=>{
     frame=null;if(!toc.isConnected){cleanup();return;}
     let current=null,nearest=-Infinity;
     targets.forEach(({link,target})=>{
      const top=target.getBoundingClientRect().top,offset=(parseFloat(getComputedStyle(target).scrollMarginTop)||100)+1;
      if(top<=offset&&top>nearest){current=link;nearest=top;}
     });
     tocLinks.forEach(link=>{if(link===current)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
    };
    const queue=()=>{if(!toc.isConnected){cleanup();return;}if(frame===null)frame=requestAnimationFrame(update);};
    ['scroll','resize','hashchange'].forEach(type=>window.addEventListener(type,queue,{passive:true}));
    owner.addEventListener('load',queue,true);toc.addEventListener('toggle',queue);
    const cleanup=()=>{
     ['scroll','resize','hashchange'].forEach(type=>window.removeEventListener(type,queue));
     owner.removeEventListener('load',queue,true);toc.removeEventListener('toggle',queue);document.removeEventListener('shopify:section:unload',unload);
     if(frame!==null)cancelAnimationFrame(frame);frame=null;delete toc.dataset.mmSpyReady;
    };
    const unload=e=>{if(e.target.contains(toc))cleanup();};
    document.addEventListener('shopify:section:unload',unload);queue();
   }
   root.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',()=>{const target=document.getElementById(a.hash.slice(1));if(target){target.setAttribute('tabindex','-1');setTimeout(()=>target.focus({preventScroll:true}),50);}}));
   const filter=root.querySelector('[data-mm-filter]');
   if(filter){
    const input=filter.querySelector('input'),cards=[...root.querySelectorAll('[data-mm-searchable]')],status=root.querySelector('[data-mm-results]'),empty=root.querySelector('[data-mm-empty]');
    const apply=()=>{const term=(input?.value||'').trim().toLocaleLowerCase();let n=0;cards.forEach(card=>{const match=(card.dataset.mmSearchable||'').toLocaleLowerCase().includes(term);card.hidden=!match;if(match)n++;});if(status)status.textContent=term?`${n} matching guides`:`${cards.length} guides`;if(empty)empty.hidden=n>0;};
    filter.addEventListener('submit',e=>{e.preventDefault();apply();});input?.addEventListener('input',apply);
    root.querySelector('[data-mm-reset]')?.addEventListener('click',()=>{input.value='';apply();input.focus();});
   }
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
